import React, { useState } from "react";

export default function TablePicker({ onPick, onBack }) {
  const [hovered, setHovered] = useState({ rows: 1, cols: 1 });
  const size = 8;
  return (
    <div style={{ minWidth: 220, maxWidth: 280, width: 260 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
        <button onClick={onBack} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', marginRight: 8 }}>&larr;</button>
        <span style={{ fontWeight: 500 }}>{hovered.cols}x{hovered.rows}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${size}, 1fr)`, gap: 6, background: '#f8f8fa', padding: 8, borderRadius: 12 }}>
        {Array.from({ length: size * size }).map((_, i) => {
          const row = Math.floor(i / size) + 1;
          const col = (i % size) + 1;
          const active = row <= hovered.rows && col <= hovered.cols;
          return (
            <div
              key={i}
              onMouseEnter={() => setHovered({ rows: row, cols: col })}
              onClick={() => onPick(row, col)}
              style={{
                width: 24, height: 24,
                borderRadius: 6,
                border: active ? '2px solid #a084e8' : '1.5px solid #d1d5db',
                background: active ? '#ede2f9' : '#f3f4f6',
                boxSizing: 'border-box',
                cursor: 'pointer',
                transition: 'background 0.15s, border 0.15s'
              }}
            />
          );
        })}
      </div>
    </div>
  );
} 